exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n\n  .list-group-item.striped:nth-child(odd) {\n    background-color: rgba(0,0,0,0.02);\n  }\n\n  label span.special {\n    color: #00F;\n  }\n\n  label span.company {\n    color: #800;\n  }\n\n  .btn-success {\n    margin-left: 5px;\n  }\n\n  .btn-danger {\n    margin-right: 5px;\n  }\n\n  .well {\n    margin-bottom: 0;\n  }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/apptexts/apptexts.component.css
// module id = ../../../../../src/app/modules/apptexts/apptexts.component.css
// module chunks = main